import { useEffect } from "react";
import "./Aarohan.css";
import { events, arhn_gallary } from "./AarohanData.js";
import './DarkVeil.css';
import AOS from "aos";
import "aos/dist/aos.css";
import DarkVeil from "./DarkVeil.js";
import "bootstrap/dist/css/bootstrap.min.css";
import { Carousel } from "bootstrap";

function Aarohan() {

  useEffect(() => {
    AOS.init({
      duration: 1200,
      easing: "ease-out-quart",
      once: true,
      offset: 100,
      delay: 50,
      anchorPlacement: "top-bottom",
      mirror: false,
      disable: window.innerWidth < 768? true : false,
    });

    const heroCarouselElement = document.querySelector("#heroCarousel");
    let bootstrapCarouselInstance = null;
    if (heroCarouselElement) {
      bootstrapCarouselInstance =
        new Carousel(heroCarouselElement, { interval: 4000, ride: "carousel", pause: false });
      bootstrapCarouselInstance.cycle();
    }

    const cursor = document.querySelector(".glow-cursor"); 
    const moveCursor = (e) => {
       if(cursor) {
         cursor.style.left = e.clientX + "px";
         cursor.style.top = e.clientY + "px";
       }
    };
    window.addEventListener("mousemove", moveCursor);

    return () => {
      if (bootstrapCarouselInstance){ bootstrapCarouselInstance.dispose();
    }
      window.removeEventListener("mousemove", moveCursor);
    };
}, []);
  const eventCards = events.map((event) => {
    let imgSrc = "";
    if (event.posters) {
      if (typeof event.posters === "string") {
        imgSrc = event.posters; 
      } else if (event.posters.src) {
        imgSrc = event.posters.src;
      } else if (Array.isArray(event.posters) && event.posters.length > 0) {
        imgSrc = event.posters[0].src;
      }
    } else {
      imgSrc = event.image || ""; 
    }
    
    return (
      <div key={event.id} className="carousel-item-wrapper w-full flex justify-center">
        <div 
          className="arhn-card"
        >
          <div className="w-full h-full p-4 flex items-center justify-center">
          <img src={imgSrc} alt={event.name} className="w-full h-auto max-h-[600px] object-contain block rounded-lg shadow-lg" />
          </div>
          <div className="arhn-card-content">
            <h2 className="absolute top-6 w-full px-4 z-20 text-2xl lg:text-3xl font-bold text-white text-center drop-shadow-xl break-words leading-tight">{event.name}</h2>
            <div className="absolute top-25 left-1/2 -translate-x-1/2 h-1 w-12 bg-red-600 rounded-full z-20 drop-shadow-md"></div>
            <p className="text-sm text-gray-300 px-4">{event.content}</p>
          </div>
        </div>
      </div>
    );
  });

return (
    <>
    <div className="darkveil-wrapper">
        <DarkVeil 
              hueShift={240}
              noiseIntensity={0.05}
              scanlineIntensity={0.15}
              speed={0.5}
              scanlineFrequency={1}
              warpAmount={3}
              resolutionScale={2}
        />
      </div>
    <div className="noise-overlay"></div>
    <div className="glow-cursor"></div>
      <div className="hero-section">
        <div
          id="heroCarousel"
          className="carousel slide carousel-fade hero-bg"
        >
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img src="./assets/img1.jpg" className="d-block w-100" alt="Hero 1" />
            </div>
            <div className="carousel-item">
              <img src="./assets/img2.jpg" className="d-block w-100" alt="Hero 2" />
            </div>
            <div className="carousel-item">
              <img src="./assets/img3.jpg" className="d-block w-100" alt="Hero 3" />
            </div>
            <div className="carousel-item">
              <img src="./assets/img4.jpg" className="d-block w-100" alt="Hero 4" />
            </div>
            <div className="carousel-item">
              <img src="./assets/img5.jpg" className="d-block w-100" alt="Hero 5" />
            </div>
          </div>
        </div>

        <div className="hero-overlay">
          <h1 className="main-title" data-aos="zoom-out" data-aos-duration="1500">
            AAROHAN
          </h1>
        </div>
      </div>

      <div className="w-full relative z-10 bg-transparent">
        
        <main className="parallax-main">
          
          <section className="parallax-section">
            <figure className="parallax-image-container">
              <img src="./IMG_0406.JPG" alt="Aarohan Who We Are" />
            </figure>
            <article className="parallax-content">
              <h1 className="parallax-title">
                WHO WE ARE
              </h1>
              <p className="text-lg text-gray-300 leading-relaxed text-center">
                Aarohan is not just a fest; it is a legacy. As the second-largest techno-management 
                fest in Eastern India, hosted by Team Aavishkar at NIT Durgapur, we have been 
                curating the future for over 50 years. It is the convergence of code, creativity, 
                and culture.
              </p>
            </article>
          </section>
         
          <section className="parallax-section">
            <figure className="parallax-image-container">
              <img src="./Roboliga_Aarohan_25_verified.png" alt="SAE X Aarohan" />
            </figure>
            <article className="parallax-content">
              <h1 className="parallax-title">
                SAE X AAROHAN
              </h1>
              <p className="text-lg text-gray-300 leading-relaxed text-center">
                The SAE India Collegiate Club of NIT Durgapur powers the mechanical heart of Aarohan. 
                From the roar of engines in Car Auction to the precision of Flying UAVs, SAE brings 
                engineering to life, transforming theoretical concepts into adrenaline-fueled reality.
              </p>
            </article>
          </section>
          </main>

        </div>

        <div className="px-6 lg:px-32 py-20">
          <div className="mb-16 text-center" data-aos="fade-up">
            <h1 className="thearena">
              The Arena
            </h1>
            <p className="text-gray-500 mt-4 tracking-widest uppercase text-lg">Our Events and Workshops in AAROHAN</p>
          </div>
          <div className="w-full max-w-12xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 justify-items-center">
            {eventCards}
          </div>
        </div>
 
        <div className="px-6 lg:px-32 py-20">
          <div className="mb-16 text-center" data-aos="fade-up">
            <h1 className="thearena">
              AAROHAN GALLERY
            </h1>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 w-full max-w-7xl mx-auto px-4">
            {arhn_gallary.map((arhn_img, idx) => (
              <div 
                key={`gallery-${idx}`} 
                className="w-full h-[250px] sm:h-[300px] md:h-[350px] rounded-xl overflow-hidden shadow-lg transition-transform duration-300 hover:scale-105 hover:shadow-2xl cursor-pointer"
              >
                <img src={arhn_img.posters} alt="gallery" className="w-full h-full object-cover block" />
              </div>
            ))}
          </div>

      </div>
    </>
  );
}

export default Aarohan;
